export default __webpack_public_path__ + "47d1a8c31f850cf7006d7570b9ec6140.mp3";